export default {
      id: "linkedin-usage",
      viewBox: "0 0 23 22",
      url: __webpack_public_path__ + "sprite.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }